import { createContext, useContext } from "react";

import { RBACMenu, RoleNameUnionType, UserPoolI } from "./auth.type";
import { RBACApplicationsType } from "../../typings/common";
import { IGetUserAccountResponse } from "../../services/userAccountService";

interface UserAccountI extends IGetUserAccountResponse {
  userPools: UserPoolI[],
  userDepartments: string[],
}
interface IAuthContext {
  user: any;
  userInfo: any;
  userAccount: UserAccountI;
  rbacInfo: Array<RBACMenu>;
  rbacRoles: Array<RoleNameUnionType>;
  appInfo: RBACApplicationsType | undefined;
  logout: () => void;
}

const AuthContext = createContext<IAuthContext>({
  user: "",
  userInfo: "",
  userAccount: {
    id: 0,
    employee_id: "",
    employee_name: "",
    employee_email: "",
    client_name: "",
    isActive: true,
    position_info: [],
    userPools: [],
    userDepartments: [],
  },
  rbacInfo: [],
  rbacRoles: [],
  appInfo: undefined,
  logout: () => ({}),
});

export default AuthContext;
